import React, {Component} from 'react';
import {Link} from 'react-router'
import LocalizedStrings from '../../../localization/strings';
import DistanceSelectField from '../../../components/stage/distance-selection';
import Icon from '../../../components/icon';
export default class ExportContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stage: null,
            distance: null
        };
    }

    onFilterChange(filterValues) {
        this.setState(filterValues);
    }

    renderDistanceExports() {
        return <div>
            <div><Icon icon="xlsx-file" size="ss"/>
                <Link to={`/api/export/stage-participants/${this.state.stage.value}`} target="_blank">{LocalizedStrings.participantsExport}</Link>
            </div>
            <div><Icon icon="xlsx-file" size="ss"/>
                <Link to={`/api/export/stage-participants-all/${this.state.stage.value}`} target="_blank">{LocalizedStrings.allParticipantsExport}</Link>
            </div>

        </div>
    }
    render() {
        return (
            <div>
                <h3>{LocalizedStrings.export}</h3>
                <div className="panel">
                    <div className="panel-body">
                        <div className="three-selects">
                            <DistanceSelectField onChange={this.onFilterChange.bind(this)}/>
                        </div>

                        <div className="mt-30">
                            {this.state.stage
                                ? this.renderDistanceExports()
                                : LocalizedStrings.selectStage}</div>
                    </div>

                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/js/containers/admin/export/export-container.js